<section id="main">
  <div class="container-fluid" >
    <!-- Account informations -->
    <div ng-if="accounts.selectedAccount" 
         class="account-header-container"
         ng-class="{'sl-flex-fix': accounts.isSloCardView}">

      <!-- Carousel navigation start -->
      <div class="row" data-ng-show="accounts.accountsForCarousel.length > 1">
        <ol class="custom-carousel-indicators pull-right">
          <li data-ng-repeat="account in accounts.accountsForCarousel"
            data-ng-class="{'active': accounts.currentIndex === account.index}"
            data-ng-click="accounts.chooseFromCarousel(account.accountId);"></li>
        </ol>
      </div>

      <div ng-show="accounts.isNextButtonVisible"  
           class="pull-right icon-container m-r-15" 
           data-ng-click="accounts.goToNextItem()">
        <a class="account-navigation-icons">
          <i class="zmdi zmdi-chevron-right zmdi-hc-4x"></i>
        </a>
      </div>

      <div ng-show="accounts.isPreviousButtonVisible" 
           class="pull-left icon-container m-l-15" 
           data-ng-click="accounts.goToPreviousItem()">
        <a class="account-navigation-icons">
          <i class="zmdi zmdi-chevron-left zmdi-hc-4x"></i>
        </a>

        
      </div>
      <!-- Carousel navigation end -->

      <div class="row account-carousel-row"
        ng-style="accounts.selectedAccount.linkList.itemList.imageUrl ?{'background-image': 'url(' + accounts.selectedAccount.linkList.itemList.imageUrl + ')'} : {'background-image': 'url(img/hypo/current_account_h200.png)'}">
        <div class="col-xs-8 account-header-inner m-l-25" ng-switch on="accounts.selectedAccount.accountType.group">
          <!-- Change name of account -->
          <div class="row">
            <div class="col-xs-12 no-padding">
              <div ng-show="accounts.isEditable == true">
                <div class="col-sm-8 m-t-14 m-b-9">
                  <input ng-if="accounts.apiLocation === 'sl'" type="text" class="form-control"
                    data-ng-model="accounts.newDescription" maxlength="50"
                    ng-pattern-restrict="{{accounts.regexPatterns.standardInputFriendlyName}}">
                  <input ng-if="accounts.apiLocation !== 'sl'" type="text" class="form-control"
                    data-ng-model="accounts.newDescription" maxlength="50">
                </div>
                <div class="col-sm-4 m-t-14 m-b-9">
                  <i class="zmdi zmdi-check zmdi-hc-2x edit-check-btn" data-ng-click="accounts.editAccount();"></i>
                </div>
              </div>

              <h2 class="account-name m-l-15" ng-show="accounts.selectedAccount.friendlyName && !accounts.isEditable">
                <span class="account-friendly-name">{{accounts.selectedAccount.friendlyName}}</span>

                <a href="" class="p-l-30 d-flex align-items-center">
                  <span class="account-edit m-r-10" data-ng-click="accounts.showEditAccount()"
                    translate="accounts.rename"></span>
                  <span data-ng-click="accounts.markAsFavorite()">
                    <i ng-if="!accounts.isFavoriteAccount" class="zmdi zmdi-star-outline "></i>
                    <i ng-if="accounts.isFavoriteAccount" class="zmdi zmdi-star is-favorite"></i>
                  </span>

                </a>
              </h2>

              <h2 class="account-name m-l-15 f-20"
                ng-show="!accounts.selectedAccount.friendlyName && !accounts.isEditable">
                <span>
                  {{accounts.selectedAccount.accountType.description}}
                </span>

                <span class="p-l-30">
                  <span class="account-edit" data-ng-click="accounts.showEditAccount()"
                    translate="accounts.rename"></span>
                    <i ng-if="!accounts.isFavoriteAccount" class="zmdi zmdi-star-outline"></i>
                  <i ng-if="accounts.isFavoriteAccount" class="zmdi zmdi-star is-favorite"></i>
                </span>

              </h2>

            </div>
            <div class="col-xs-12 p-b-10" ng-show="accounts.isEditable">

              <span class="account-edit" translate="accounts.accResetName"
                data-ng-click="accounts.resetAccountName()"></span>
            </div>
          </div>
          <span ng-if="accounts.selectedAccount.iban && !accounts.isSloCardView">
            <span class="account-name-iban">{{accounts.selectedAccount.iban}} &nbsp;</span>
          </span>
          <span ng-if="!accounts.isSloCardView">
            <span class="account-name-iban">{{accounts.selectedAccount.ownerName}}</span>
          </span>

          <!--CURRENT-->
          <div ng-switch-when="CurrentAccount">
            <div data-ng-include="'accounts/CurrentAccount-detail.tpl.html'"></div>
          </div>
          <!--LOAN-->
          <div ng-switch-when="LoanAccountType">
            <div data-ng-include="'accounts/LoanAccountType-detail.tpl.html'"></div>
          </div>
          <!--CARD-->
          <div ng-switch-when="CardAccountTypes">
            <div data-ng-include="'accounts/CardAccountTypes-detail.tpl.html'"></div>
          </div>
          <!--SAVING ACCOUNT-->
          <div ng-switch-when="SavingAccountTypes">
            <div data-ng-include="'accounts/SavingAccountTypes-detail.tpl.html'"></div>
          </div>
          <!-- GIRO ACCOUNT-->
          <div ng-switch-when="GiroAccount">
            <div data-ng-include="'accounts/GiroAccount-detail.tpl.html'"></div>
          </div>
          <!--DEPOSIT-->
          <div ng-switch-when="DepositAccountTypes">
            <div data-ng-include="'accounts/DepositAccountTypes-detail.tpl.html'"></div>
          </div>
        </div>

        <div class="col-xs-4">
          <!-- TODO: Add image based on account type -->
        </div>
      </div>

      <!-- Accounts & card details bottom part -->
      <div class="account-details-container clearfix">
        <div ng-if="accounts.apiLocation!= 'sr' && !accounts.isSloCardView"
          ng-hide="accounts.isAccountDetailsOpen"
          class="account-open-more-details" data-ng-click="accounts.toggleAccountDetails()"
          translate="accounts.accAccountAndCardsMoreDetails">
        </div>
        <div class="account-open-more-details"
          ng-if="!accounts.isAccountDetailsOpen &&
                                                            accounts.apiLocation== 'sr' &&
                                                            accounts.selectedAccount.accountType.group !== 'LoanAccountType' &&
                                                            accounts.selectedAccount.accountType.group !== 'DepositAccountTypes' "
          data-ng-click="accounts.toggleAccountDetails()" translate="accounts.accAccountAndCardsMoreDetails1">
        </div>
        <div class="account-open-more-details"
          ng-if="!accounts.isAccountDetailsOpen &&
                                                            accounts.apiLocation== 'sr' &&
                                                            (accounts.selectedAccount.accountType.group === 'LoanAccountType' ||
                                                            accounts.selectedAccount.accountType.group === 'DepositAccountTypes') "
          data-ng-click="accounts.toggleAccountDetails()" translate="accounts.accAccountAndCardsMoreDetails">
        </div>

        <div ng-if="accounts.selectedAccount.cardList && accounts.apiLocation == 'sl'">
          <div data-ng-include="'accounts/shared/connected-debit-card/connected-debit-card-slo.tpl.html'"></div>
          <p class="p-3" translate="accounts.waitingQueueTransactionsDisclaimer"></p>
        </div>

        <div ng-if="accounts.isAccountDetailsOpen">

          <!-- Connected debit cards-->
          <div
            ng-if="accounts.selectedAccount.cardList && 
                                    (accounts.apiLocation == 'sr' || accounts.apiLocation == 'bh' || accounts.apiLocation == 'mn')">
            <div data-ng-include="'accounts/shared/connected-debit-card/connected-debit-card.tpl.html'"></div>
          </div>

          <!-- SavingAccountTypes - Documents -->
          <div ng-if="accounts.selectedAccount.accountType.group === 'SavingAccountTypes'"
            ng-hide="accounts.apiLocation != 'hr'" class="m-t-15">
            <div class="row m-l-5">
              <a data-ng-click="accounts.downloadFile_ESavingBook('DocumentRequest')"
                style="text-decoration: underline; font-weight: bold;font-size: 15px; cursor: pointer;"
                translate="ebook.doc1"></a>
            </div>
            <div class="row m-l-5 m-t-5">
              <a data-ng-click="accounts.downloadFile_ESavingBook('PreContractForm')"
                style="text-decoration: underline; font-weight: bold;font-size: 15px; cursor: pointer;"
                translate="ebook.doc2"></a>
            </div>

            <div class="row m-l-5 m-t-5">
              <a ng-href="{{APP_GLOBAL_SETTINGS.defaultData.eSavings_generalTerms}}" target="_blank"
                style="text-decoration: underline; font-weight: bold;font-size: 15px; cursor: pointer;"
                translate="ebook.doc4"></a>
            </div>
            <div class="row m-l-5 m-t-5">
              <a ng-href="{{APP_GLOBAL_SETTINGS.defaultData.Deposit_basicInfo}}" target="_blank"
                style="text-decoration: underline; font-weight: bold;font-size: 15px; cursor: pointer;"
                translate="ebook.informationFormOnDeposits"></a>
            </div>

            <div class="row m-l-5 m-t-5" style="font-weight: bold;font-size: 15px">
              <span translate="ebook.otherDocs1"></span>
              <a href="https://www.addiko.hr/gradanstvo/opci-uvjeti-poslovanja-naknade-gradanstvo/" target="_blank"
                style="text-decoration: underline; font-weight: bold;font-size: 15px; cursor: pointer;">
                <span translate="ebook.otherDocs2"></span>
              </a>
            </div>
          </div>

          <!-- DepositAccountTypes - Documents -->
          <div ng-if="accounts.selectedAccount.accountType.group === 'DepositAccountTypes'"
            ng-hide="accounts.apiLocation != 'hr'" class="m-t-15">
            <div class="row m-l-5">
              <a data-ng-click="accounts.downloadFile_Deposits('Contract')"
                style="text-decoration: underline; font-weight: bold;font-size: 15px; cursor: pointer;"
                translate="termDeposit.hrDoc6"></a>
            </div>
            <div class="row m-l-5 m-t-5">
              <a data-ng-click="accounts.downloadFile_Deposits('PreContractInfo')"
                style="text-decoration: underline; font-weight: bold;font-size: 15px; cursor: pointer;"
                translate="termDeposit.hrDoc7"></a>
            </div>
            <div class="row m-l-5 m-t-5" style="font-weight: bold;font-size: 15px">
              <span translate="termDeposit.otherDocs1"></span>
              <a href="https://www.addiko.hr/gradanstvo/opci-uvjeti-poslovanja-naknade-gradanstvo/" target="_blank"
                style="text-decoration: underline; font-weight: bold;font-size: 15px; cursor: pointer;">
                <span translate="termDeposit.otherDocs2"></span>
              </a>
            </div>
          </div>

          <!-- Authorized persons -->
          <div class="row col-sm-12 p-0" ng-if="accounts.selectedAccount.accountType.group !== 'LoanAccountType'">
            <div ng-hide="accounts.apiLocation == 'sl'" class="account-container m-l-25 m-r-25">
              <span class="acrs-acc-info-text m-b-5 auth-persons-text" translate="accounts.accAuthorizedPersons"></span>
              <hr class="account-header-line" />

              <div class="ac-authorized-person-container"
                data-ng-repeat="item in accounts.selectedAccount.userAccountListFiltered">
                <span>{{item.user.firstName}} {{item.user.lastName}} </span>
              </div>
            </div>
          </div>

          <div class="col-md-12"
            ng-if="accounts.selectedAccount.accountType.group == 'CurrentAccount' && (accounts.apiLocation == 'hr')">
            <button class="btn btn-default app-btn-blue m-t-15 m-b-10" translate="orders.largeAmount"
              ng-click="accounts.goToCashWithdrawal()">
              Large amount of cash withdrawal
            </button>
          </div>
          <div class="col-md-12"
            ng-if="accounts.selectedAccount.accountType.group == 'CurrentAccount' && (accounts.apiLocation == 'sl') && accounts.selectedAccount.canCashWithDrawal">
            <button class="btn btn-default app-btn-blue m-t-15 m-b-10" translate="orders.largeAmount"
              ng-click="accounts.goToCashWithdrawal()">
              Large amount of cash withdrawal
            </button>
          </div>

        </div>

        <div ng-if="accounts.isAccountDetailsOpen" class="row col-xs-12">
          <span class="account-open-more-details" 
            data-ng-click="accounts.toggleAccountDetails()" translate="accounts.accAccountAndCardsLessDetails">
          </span>
        </div>
      </div>
    </div>

    <div class="row" ng-if="accounts.selectedAccount.accountType.group === 'CurrentAccount'">
      <div ng-hide="accounts.apiLocation== 'hr' && accounts.defaultCurrency != accounts.selectedAccount.currencySymbol"
        class="col-xs-12">
        <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5"
          ng-hide="accounts.multiCurrency || (accounts.apiLocation== 'bh' && accounts.defaultCurrency != accounts.selectedAccount.currencySymbol)">
          <a data-ui-sref="payments.domesticPayment.fromAccount({accountId: accounts.selectedAccount.accountId})">
            <div class="round-btn-container">
              <!--<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>-->
              <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>
              <div class="round-btn-label">{{'dashboard.domesticPaymentBtn1'|translate}}
                <br>{{'dashboard.domesticPaymentBtn2'|translate}}
              </div>
            </div>
          </a>
        </div>
        <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">
          <a ng-click="accounts.goToInternalPayment();" ng-if="!accounts.multiCurrency">
            <div class="pointer round-btn-container">
              <!--<div class="round-btn"><i class="zmdi zmdi-swap zmdi-hc-3x"></i></div>-->
              <div class="round-btn"><i class="icon icon-transfer" style="font-size:2em"></i></div>
              <div class="round-btn-label">{{'dashboard.transferBtn1'|translate}}
                <br>{{'dashboard.transferBtn2'|translate}}
              </div>
            </div>
          </a>
          <a ng-click="accounts.goToForeignCurrencyTransfer()" ng-if="accounts.multiCurrency">
            <div class="pointer round-btn-container">
              <!--<div class="round-btn"><i class="zmdi zmdi-swap zmdi-hc-3x"></i></div>-->
              <div class="round-btn"><i class="icon icon-transfer" style="font-size:2em"></i></div>
              <div class="round-btn-label">{{'dashboard.transferBtn1'|translate}}
                <br>{{'dashboard.transferBtn2'|translate}}
              </div>
            </div>
          </a>

        </div>

        <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">
          <div
            ng-hide="accounts.apiLocation == 'bh' && APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency != accounts.selectedAccount.currencySymbol"
            class="pointer round-btn-container" ng-click="accounts.loadPaymentTemplates();">
            <div class="round-btn"><i class="icon icon-template" style="font-size:1.6em"></i></div>
            <div class="round-btn-label">{{'dashboard.templateBtn1'|translate}}
              <br>{{'dashboard.templateBtn2'|translate}}
            </div>
          </div>

          <div class="templates-container animated fadeIn" ng-show="accounts.showTemplatesView">
            <div class="form-group m-b-0">
              <div class="input-group" style="height:50px;border: 1px solid black;">
                <div class="input-group-btn srch-icon" style="border:1px solid lightgray; border-right:none;">
                  <button class="btn" type="submit" style="box-shadow:none;background-color: transparent;">
                    <i class="glyphicon glyphicon-search" style="font-size:20px;"></i>
                  </button>
                </div>
                <input id="searchTemplatesInput" style="height:50px;" data-ng-model="accounts.searchTemplates"
                  type="text" class="form-control srch-input"
                  placeholder="{{'dashboard.searchTemplatesPlaceholder' | translate}}"
                  ng-change="accounts.showTemplatesView = (accounts.searchTemplates == '') ? false : true">
              </div>
            </div>
            <div class="p-10 templates-search-container" scrollable>
              <div class="m-b-10">
                <h4 translate="templateSearch.templatesList"></h4>
                <div class="list-group">
                  <a href="" class="list-group-item"
                    data-ng-repeat="template in accounts.templateList.result | filter:accounts.searchTemplates"
                    ng-click="accounts.navigateToPaymentForm({id: template.id, type: template.paymentTypeGroup, template: template})">
                    <div class="row">
                      <div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>
                      <div class="col-xs-11">
                        <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>
                        <p class="list-group-item-text">{{template.toAccountNumber}}</p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- SLO - change withdrawal limit -->
        <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5"
          ng-if="accounts.apiLocation=== 'sl' && accounts.selectedAccount.currencySymbol == 'EUR' && accounts.selectedAccount.isOwn == true && APP_GLOBAL_SETTINGS.userSettings.isResident == 'Y'">
          <a ng-click="accounts.goToChangeWithdrawal()">
            <div class="round-btn-container">
              <!--<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>-->
              <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>
              <div class="round-btn-label">{{'navigation.withdrawal1'|translate}}
                <br>{{'navigation.withdrawal2'|translate}}
              </div>
            </div>
          </a>
        </div>
        <!-- SLO - change ATM withdrawal limit -->
        <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5"
          ng-if="accounts.apiLocation=== 'sl' && accounts.selectedAccount.currencySymbol == 'EUR' && accounts.selectedAccount.isOwn == true">
          <a data-ui-sref="changeATMWithdrawal({accountId: accounts.selectedAccount.accountId})">
            <div class="round-btn-container d-flex align-items-center">
              <!--<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>-->
              <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>
              <div class="round-btn-label">{{'navigation.changeATMWithdrawal1'|translate}}
                <br>{{'navigation.changeATMWithdrawal2'|translate}}
              </div>
            </div>
          </a>
        </div>
        <!-- SHOW FOR NOW - PIN OVER SMS - START -->
        <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5"
          ng-if="accounts.apiLocation=== 'sl' && accounts.selectedAccount.currencySymbol == 'EUR' && accounts.selectedAccount.isOwn == true">
          <a data-ui-sref="reorderPinAccounts({accountId: accounts.selectedAccount.accountId})">
            <div class="round-btn-container">
              <div class="round-btn">
                <div class="icon icon-addiko-pin" style="font-size:2em">
                </div>
              </div>
              <div class="round-btn-label">{{'navigation.reorderPin'|translate}}</div>
            </div>
          </a>
        </div>
        <!-- SHOW FOR NOW - PIN OVER SMS - END -->
      </div>
    </div>



    <!-- Account actions -->
    <div class="m-b-15">
      <div ng-if="accounts.selectedAccount.accountType.group === 'LoanAccountType'">
        <div class="col-xs-12">
          <div ng-hide="accounts.apiLocation == 'bh' && accounts.selectedAccount.accountType.id != '1801'"
            style="padding-left: 1px;">
            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">
              <div class="round-btn-container"
                data-ng-click="accounts.goToLoanPayment(); accounts.pushGtmPayInEvent('LoanAccount');">
                <div class="round-btn"><i class="icon icon-epayin" style="font-size:2em"></i></div>
                <div class="round-btn-label" translate="accounts.accPayIn" style="padding-top:22px;"></div>
              </div>

            </div>
          </div>

          <div style="padding-left: 1px;" ng-if="(accounts.apiLocation == 'sr' || accounts.apiLocation == 'mne')"
            data-ng-click="accounts.toggleRepaymentPlan()">

            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">
              <div class="round-btn-container">
                <div class="round-btn"><i class="icon icon-epayin" style="font-size:2em"></i></div>
                <div ng-if="accounts.showRepaymentPlan" class="round-btn-label" translate="accounts.closeRepaymentPlan"
                  style="padding-top:22px;">
                </div>
                <div ng-if="!accounts.showRepaymentPlan" class="round-btn-label" translate="accounts.accRepaymentPlan"
                  style="padding-top:22px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-3 col-xs-12 m-b-20"
          ng-if="accounts.selectedAccount.accountType.group === 'CardAccountTypes' && accounts.selectedAccount.linkList.itemList.payIn">
          <div class="pointer round-btn-container">
            <div class="round-btn"><i class="icon icon-ebin" style="font-size:2em"></i></div>
            <div class="round-btn-label" translate="accounts.accPayIn"
              data-ng-click="accounts.goToInternalPayment(); accounts.pushGtmPayInEvent('CardAccount');"></div>
          </div>
        </div>

        <div class="col-sm-3 col-xs-12 m-b-20"
              ng-if="accounts.selectedAccount.accountType.group === 'CardAccountTypes' && accounts.selectedAccount.isOwn && accounts.apiLocation == 'sl'">
              <a ng-click="accounts.goToCardPayment()">
              <div class="pointer round-btn-container">
                <div class="round-btn"><i class="icon icon-ebin" style="font-size:2em"></i></div>
                <div class="round-btn-label">
                    {{'dashboard.domesticPaymentCardBtn1' | translate}} <br> {{'dashboard.domesticPaymentCardBtn2' | translate}}    
                </div>
              </div>
              </a>
          
        </div>

        <!-- Transaction division button (specific for BiH, SRB and MNE environments) -->
        <div class="col-sm-3 col-xs-12 m-b-20"
          ng-if="accounts.selectedAccount.linkList && accounts.selectedAccount.linkList.itemList.transactionDivisionLink">
          <a data-ui-sref="transactionDivison.create({
                    accountId:accounts.selectedAccount.accountId, 
                    currency: accounts.selectedAccount.currencySymbol,
                    card: accounts.selectedAccount.accountNumber.substr(accounts.selectedAccount.accountNumber.length - 4, 4), 
                    accountTypeId: accounts.selectedAccount.accountType.id
                    })">
            <div class="pointer round-btn-container">
              <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>
              <div class="round-btn-label">{{'accounts.transDivisionBtn1'|translate}}
                <br>{{'accounts.transDivisionBtn2'|translate}}
              </div>
            </div>
          </a>
        </div>
        <!-- End Transaction division button (specific for BiH, SRB and MNE environments) -->
      </div>

      <!--MNE SPECIFIC START-->
      <div ng-if="(accounts.selectedAccount.accountType.group === 'SavingAccountTypes' || accounts.selectedAccount.accountType.group === 'DepositAccountTypes') &&
                    accounts.apiLocation === 'mne' && (accounts.selectedAccount.accountType.id.substr(0,2) === '60')">

        <button type="input" class="btn btn-default app-btn-blue m-t-5"
          ng-if="accounts.selectedAccount.accountType.id !== 'SVGSUB'"
          data-ng-click="accounts.goToSavingsPayIn(accounts.selectedAccount); accounts.pushGtmPayInEvent('DepositAccount');"
          translate="accounts.accPayIn"></button>
      </div>
      <!--MNE SPECIFIC END-->
      <div ng-if="accounts.selectedAccount.accountType.group === 'SavingAccountTypes' && accounts.apiLocation != 'mne'">
        <div class="col-xs-12 m-b-10">
          <div class="col-xs-12 col-sm-4">
            <div class="pointer round-btn-container">

              <div class="round-btn" ng-if="accounts.selectedAccount.accountType.id === 'SVGSUB'"
                data-ng-click="accounts.goToEbookPay('Pay In'); accounts.pushGtmPayInEvent('Ebook');"><i
                  class="icon icon-ebin" style="font-size:2em"></i>
              </div>
              <div class="round-btn-label" ng-if="accounts.selectedAccount.accountType.id === 'SVGSUB'"
                data-ng-click="accounts.goToEbookPay('Pay In'); accounts.pushGtmPayInEvent('Ebook');"
                translate="accounts.eBookPayIn">

              </div>

              <div class="round-btn" ng-if="accounts.selectedAccount.accountType.id !== 'SVGSUB'"
                data-ng-click="accounts.goToSavingsPayIn(accounts.selectedAccount); accounts.pushGtmPayInEvent('SavingsAccount');">
                <i class="icon icon-ebin" style="font-size:2em"></i>
              </div>
              <div class="round-btn-label" ng-if="accounts.selectedAccount.accountType.id !== 'SVGSUB'"
                data-ng-click="accounts.goToSavingsPayIn(accounts.selectedAccount); accounts.pushGtmPayInEvent('SavingsAccount');"
                translate="accounts.accPayIn">
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4">
            <div class="pointer round-btn-container" ng-if="accounts.selectedAccount.accountType.id === 'SVGSUB'">
              <div class="round-btn"><i class="icon icon-ebout" style="font-size:2em"></i></div>
              <div class="round-btn-label" data-ng-click="accounts.goToEbookPay('Pay Out')"
                translate="accounts.eBookPayOut"></div>
            </div>
          </div>
          <!--<button type="input" class="btn btn-default app-btn-blue m-t-5" ng-if="accounts.selectedAccount.accountType.id === 'SVGSUB'"-->
          <!--translate="accounts.accNewEbook" data-ng-click="accounts.goToNewEbook()"></button>-->
          <div ng-switch="accounts.apiLocation">
            <div ng-switch-default class="col-xs-12 col-sm-4">
              <div class="pointer round-btn-container" ng-if="accounts.selectedAccount.accountType.id === 'SVGSUB'">
                <div class="round-btn"><i class="icon icon-ebclose" style="font-size:2em"></i></div>
                <div class="round-btn-label" translate="accounts.closeEbook"
                  data-ng-click="accounts.closeEbook(accounts.selectedAccount.accountId)">
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4" ng-switch-when="hr"
              ng-show="accounts.selectedAccount.currencySymbol == accounts.defaultCurrency">
              <div class="pointer round-btn-container" ng-if="accounts.selectedAccount.accountType.id === 'SVGSUB'">
                <div class="round-btn"><i class="icon icon-ebclose" style="font-size:2em"></i></div>
                <div class="round-btn-label" translate="accounts.closeEbook"
                  data-ng-click="accounts.closeEbook(accounts.selectedAccount.accountId)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div ng-if="accounts.selectedAccount.accountType.group === 'DepositAccountTypes'">
        <div class="row" style="padding-left: 1px;" ng-if="accounts.apiLocation=='hr'">
          <div class="col-xs-12">
            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">
              <div class="round-btn-container">
                <div class="round-btn"><i class="icon icon-close" style="font-size:2em"></i></div>
                <div class="round-btn-label" translate="accounts.accCancelDeposit"
                  data-ng-click="accounts.cancelDepositAction()" style="padding-top:22px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div
        ng-if="accounts.selectedAccount.accountType.group === 'CurrentAccount' && accounts.apiLocation=='hr' && accounts.defaultCurrency == accounts.selectedAccount.currencySymbol">
        <div class="row" style="padding-left: 1px;">
          <div class="col-xs-12">
            <div ng-if="accounts.selectedAccount.currencySymbol == accounts.defaultCurrency"
              class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">
              <div class="round-btn-container">
                <div class="round-btn"><i class="icon icon-ebnew" style="font-size:2em"></i></div>
                <div class="round-btn-label" translate="accounts.accNewEbook" data-ng-click="accounts.goToNewEbook()">
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">
              <div class="round-btn-container">
                <div class="round-btn"><i class="icon icon-epayin" style="font-size:2em"></i></div>
                <div class="round-btn-label" translate="accounts.eBookPayIn"
                  data-ng-click="accounts.goToEbookPay('Pay In')"></div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">
              <div class="round-btn-container">
                <div class="round-btn"><i class="icon icon-eborder" style="font-size:2em"></i></div>
                <!-- Displaying ebook saving requests -->
                <div class="round-btn-label" ng-class="{'ebook-req-btn': accounts.displayeBookSavingRequest}"
                  data-ng-click="accounts.showeSavingBookRequests();" translate="ebook.eBookRequests"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Transactions & PDF statements -->
      <div ng-if="!accounts.isSloCardView && accounts.accountLoaded && accounts.apiLocation === 'mne' && (accounts.selectedAccount.accountType.group!='LoanAccountType'
        && (accounts.selectedAccount.accountType.id.substr(0,2) === '60' || accounts.selectedAccount.accountType.group!='DepositAccountTypes')
        && !accounts.displayeBookSavingRequest)" class="col-sm-12 p-0 m-b-0 app-white-card no-bottom-radius">
        <div data-ng-include="'accounts/accountsSubmenu.tpl.html'"></div>
      </div>
      <div ng-if="!accounts.isSloCardView && accounts.accountLoaded && accounts.apiLocation != 'mne' && (accounts.selectedAccount.accountType.group!='LoanAccountType'
        && accounts.selectedAccount.accountType.group!='DepositAccountTypes'
        && !accounts.displayeBookSavingRequest)" class="col-sm-12 p-0 m-b-0 app-white-card no-bottom-radius">
        <div data-ng-include="'accounts/accountsSubmenu.tpl.html'"></div>
      </div>

      <!-- START Repayment plan-->
      <div ng-if="accounts.showRepaymentPlan && !accounts.displayeBookSavingRequest"
        class="col-sm-12 col-md-12 p-0 m-b-0 app-white-card no-bottom-radius">
        <div data-ng-include="'accounts/repayment-plan.tpl.html'"></div>
      </div>
      <!-- END Repayment plan-->

      <!-- EBookSavings requests timeline -->
      <div ng-if="accounts.displayeBookSavingRequest">
        <div data-ng-include="'accounts/tl-ebook-savings.tpl.html'">
        </div>
      </div>
    </div>
  </div>
</section>